// extracted by mini-css-extract-plugin
export default {"container":"EditRoom_container__6JKY0"};